export const SOCIAL_LINKS = {
  youtube: "https://www.youtube.com/@DreamCoachMatch",
  facebook: "https://www.facebook.com/p/Dream-Coach-Match-61579015583736/",
  linkedin: "https://www.linkedin.com/company/dream-coach-match/",
} as const;

// Verified external profile that unambiguously identifies the brand, used for
// schema `sameAs` (entity disambiguation) and the ICF partner box. It is not a
// social-media profile, so it's kept out of SOCIAL_LINKS (which renders as
// social icons).
export const ICF_PARTNER_URL =
  "https://coachingfederation.org/partner/dream-coach-match/";
